import React from 'react'
import Loadable from 'react-loadable'

import { ConfigProvider as ConfigProvider5 } from 'antd-v5';
import zhCN5 from 'antd-v5/lib/locale/zh_CN';
import { ConfigProvider as ConfigProvider4 } from 'antd';
import zhCN4 from 'antd/lib/locale/zh_CN';
// antd-v5 使用 dayjs 配置中文
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

const LoadableComponent = (component) => {
  return Loadable({
    loader: component,
    render: (loaded, props) => {
      const Component = loaded.default;
      return (
        <ConfigProvider5 prefixCls="ant5" locale={zhCN5}>
          <ConfigProvider4 prefixCls="ant" locale={zhCN4}>
            <Component {...props}></Component>
          </ConfigProvider4>
        </ConfigProvider5>
      );
    },
    loading: () => <div style={style}></div>
  })
}

const style = {
  minHeight: '100%',
  width: '100%',
}

export default LoadableComponent
